export const META_PIXEL_ID = '1367632915547845'

export const PRODUCT_NAME =
  'Sewing & Pattern Making Instructor Atlas — The Complete 6-in-1 Visual Sewing, Pattern Making & Garment Construction System for Sewing Instructors, Pattern-Making Teachers & Sewing Academies'
export const PRODUCT_PRICE = 27

type PixelWindow = Window & {
  fbq?: (event: string, name: string, data?: Record<string, string | number>) => void
}

export function trackCheckout(): void {
  if (typeof window === 'undefined') return
  const pixelWindow = window as PixelWindow
  pixelWindow.fbq?.('track', 'InitiateCheckout', {
    content_name: PRODUCT_NAME,
    value: PRODUCT_PRICE,
    currency: 'USD',
  })
}
